// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__delayed-block[data-v-1dbc2d5d]{min-height:1px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
